async function initMap() {
	const restaurantLocation = {
		lat: -36.3589572,
		lng: 146.6861207
	};

	// Create the map
	const map = new google.maps.Map(document.getElementById("map"), {
		zoom: 16.25,
		center: restaurantLocation,
		mapTypeControl: false,
		scaleControl: true,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		styles: [
			{
				featureType: "poi.business",
				stylers: [{ visibility: "off" }]
			},
			{
				featureType: "transit",
				elementType: "labels.icon",
				stylers: [{ visibility: "off" }]
			}
		]
	});

	// Custom marker icon
	const markerIcon = {
		url: 'https://cdn.shopify.com/s/files/1/0747/7153/0005/files/the-last-supper-club-map-marker.png?v=1756949040&width=80',
		size: new google.maps.Size(80, 86),
	};

	// Create custom marker
	const marker = new google.maps.Marker({
		position: restaurantLocation,
		map: map,
		title: "The Last Supper Club",
		icon: markerIcon,
		animation: google.maps.Animation.DROP
	});

	// Make marker clickable - opens directions in new tab
	marker.addListener("click", () => {
		window.open(`https://www.google.com/maps/place/The+Last+Supper+Club/@-36.3590552,146.681317,17z/data=!3m1!4b1!4m6!3m5!1s0x6b26b1726b4a5555:0xcbdc16cae75cd1d1!8m2!3d-36.3590596!4d146.6861879!16s%2Fg%2F11s3jgzdpw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D`, "_blank");
	});

	// Add bounce animation on hover (optional)
	marker.addListener("mouseover", () => {
		marker.setAnimation(google.maps.Animation.BOUNCE);
	});

	marker.addListener("mouseout", () => {
		marker.setAnimation(null);
	});

	// Recenter map on window resize
	window.addEventListener("resize", () => {
		map.setCenter(restaurantLocation);
	});
}
